"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

/**
 * Default marketplace spinner.
 *
 * @param {Object} props
 * @param {BoxProps} props.wrapperProps
 * @param {string} props.image
 *
 * @returns {React.ReactElement}
 */
var MarketplaceSpinner = function MarketplaceSpinner(_ref) {
  var image = _ref.image,
      wrapperProps = (0, _objectWithoutProperties2["default"])(_ref, ["image"]);
  return /*#__PURE__*/_react["default"].createElement(_material.Box, (0, _extends2["default"])({
    width: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mt: 4,
    mb: 4
  }, wrapperProps), /*#__PURE__*/_react["default"].createElement("img", {
    src: image,
    alt: "Loader"
  }));
};

var _default = MarketplaceSpinner;
exports["default"] = _default;